import { createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { PageHeader } from './-components/PageHeader';
import Table from './-components/Table';
import TableHeader from './-components/TableHeader';
import { useStorageIntegrationsTable } from './-hooks/useTable';

export const Route = createFileRoute('/_staff/storage-files/_list/settings/')({
  component: Settings,
});

function Settings() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.storageFiles.settings',
  });

  useDocumentTitle(t('pageTitle'));

  const { table, displayState } = useStorageIntegrationsTable();

  return (
    <VStack className="mx-auto w-[1000px] py-12 gap-8">
      <PageHeader />

      <VStack className="gap-6">
        <TableHeader />
        <Table table={table} displayState={displayState} />
      </VStack>
    </VStack>
  );
}
